import { Toast, Indicator, MessageBox } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
import { removeStore } from '@/utils/session'
import { SoHo, NotFindKeyFeedback, SecondNotFindKeyFeedback, KeyRelationTimeGet } from '@/api/detailPage'
import { ProductFavoriteAdd } from '@/api/remind'
import { CancelSaleTaskAccept } from '@/api/my'
import HowToSearchMainCard from '@/components/common/HowToSearchPopup/components/HowToSearchMainCard'
import { Popup } from 'vant'
import QrcodePart from '../commonMode/component/QrcodePart'
import { PLATFORM_TYPE_DETAIL } from '@/constants/index'
import LaunchAppBtn from '@/components/common/LaunchAppBtn/index'

/**
 * 购买第一步重用代码（拼多多，淘宝，普通模式，基础销量模式）
 * 除[findProduct、showCourse、returnBeforeRoute、changeToFreeCard]方法
 */
export default {
  data() {
    return {
      productID: '',
      soHoInfo: {},
      configCondition: null,
      WAPPicUrl: '',
      isCounting: true,
      isShowCopy: false,
      diffSeconds: 0,
      mimutes: 0,
      countInterval: null,
      isFeedback: false,
      isSetting: false,
      // 关联次数（买手反馈次数）
      relationCount: 0,
      // 名额被抢光
      isNoProduct: false,
      isRemind: false,
      // 是否是免单卡
      isFreeCard: false,
      // 是否取消免单卡购买
      isCancelFreeCard: false,
      goodsRemark: null, // 商品备注
      remarkArr: [],
      sheetVisible: false,
      actionsList: [
        {
          name: '找不到',
          method: this.freeCardUnFindKey
        },
        {
          name: '不想买了',
          method: this.cancelOrder
        }
      ],
      isShowHowToSearchPopup: false, // 是否展示如何搜索弹窗
      currentPageInfo: null // 当前要传递给如何搜索弹窗的页面信息
    }
  },
  components: {
    'how-to-search-main-card': HowToSearchMainCard,
    'van-popup': Popup,
    QrcodePart,
    LaunchAppBtn
  },
  watch: {
    getIsHorizontalScreen() {
      this.setCopyGuideInfo()
    }
  },
  computed: {
    ...mapGetters(['getSoHoInfo', 'getIsHorizontalScreen']),
    haveScreen() {
      let haveScreen = 0
      // 存在筛选条件
      if (
        this.soHoInfo.SortType !== 0 ||
        this.soHoInfo.IsFreeShipping ||
        this.soHoInfo.IsTmall ||
        this.soHoInfo.IsGiveFI ||
        this.soHoInfo.IsLimitPrice ||
        this.soHoInfo.SendAddress ||
        this.soHoInfo.ConfigCondition
      ) {
        haveScreen = 1
      }
      return haveScreen
    }
  },
  methods: {
    ...mapMutations(['SET_SOHO_INFO', 'SET_QRCODE_POPUP', 'SET_ACCURATE_MODE', 'SET_CONFIG_ACCURATE_MODE']),
    stepOneTitleFilter({ PlatformType = 0, SearchType = 0 } = null) {
      let tempStr = ''
      let collectively = PLATFORM_TYPE_DETAIL[PlatformType].collectively
      switch (SearchType) {
        case 5:
          // 视频口令模式
          tempStr = `请复制下方关键词，打开${collectively}进入视频。若无法识别，请在搜索栏粘贴进入`
          break
        case 6:
          // 直播口令模式
          tempStr = `请复制下方关键词，打开${collectively}进入直播间。若无法识别，请在搜索栏粘贴进入`
          break
        case 7:
          // 二维码模式
          tempStr = `请点击下方二维码，长按保存到相册。前往${collectively}APP扫描二维码，找到与底部图片一致的商品`
          break
        default:
          // 其他模式
          tempStr = `请前往${collectively}APP搜索下方关键词，并找到与下方图片一致的商品`
          break
      }
      return tempStr
    },
    // 如何搜索
    showCourse(indexStep) {
      this.setCurrentPageInfo()
      console.log(this.soHoInfo)
      let { PlatformType, SearchType } = this.soHoInfo
      if (PlatformType === 3 && indexStep === 1) {
        this.$router.push({
          name: 'courseStepOfDy',
          query: {
            SearchType
          }
        })
      } else {
        this.$router.push({
          name: 'courseStep',
          query: {
            haveScreen: this.currentPageInfo.haveScreen,
            indexStep: indexStep,
            // 平台 --> 0：淘宝（默认）1：拼多多
            platform: this.currentPageInfo.platform
          }
        })
      }
    },
    // 是否是二维码模式
    isQrcodeMode(SearchType) {
      return [this.SEARCH_TYPE['二维码']].includes(SearchType)
    },
    // 设置当前页面信息
    setCurrentPageInfo() {
      this.currentPageInfo = {
        haveScreen: this.haveScreen, // 是否有筛选条件
        indexStep: 1, // 当前步骤
        platform: this.soHoInfo.PlatformType, // 平台 --> 0：淘宝（默认）1：拼多多、2：京东、3抖音
        SearchType: this.soHoInfo.SearchType // App自然搜索 = 0, PC自然搜索 = 1, APP直通车 = 2, PC直通车 = 3, 分享口令 = 4, 视频口令 = 5, 直播口令 = 6, 二维码 = 7
      }
    },
    // 复制按钮事件
    copyKeyBtnEvent() {
      this.copyKeyWord(() => {
        if (this.isShowHowToSearchPopupHandler(this.soHoInfo.SearchType)) {
          this.setCurrentPageInfo()
          this.setCopyGuideInfo()
        }
      })
    },
    fetchOpenShouhuoData(baseModeFn) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      return SoHo({ productID: this.productID, isFreeCard: this.isFreeCard, isFirst: false })
        .then((res) => {
          Indicator.close()
          if (res.SoHoInfo.IsOtherApply && !this.isFreeCard) {
            MessageBox({
              title: '提示',
              message: '存在一个订单未完成，请完成后再回来吧',
              showCancelButton: true,
              confirmButtonText: '去完成',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') {
                this.$router.push({
                  name: 'order',
                  query: {
                    tabIndex: 1
                  }
                })
              }
            })
          } else {
            // 关键词精确模式开关配置、关键词精确模式
            this.SET_ACCURATE_MODE(res.AccurateMode)
            this.SET_CONFIG_ACCURATE_MODE(res.ConfigAccurateMode)
            this.soHoInfo = res.SoHoInfo
            if (this.soHoInfo.ConfigCondition) this.configCondition = this.soHoInfo.ConfigCondition.split(',')
            this.handleKeyAndTime(baseModeFn)
          }
        })
        .catch((res) => {
          Indicator.close()
          if (res.ErrMsg === '抱歉哟，名额已被抢光，请选择其他商品') {
            // TODO: 名额被抢光
            this.isNoProduct = true
          }
          if (
            /在近\d+天内已购买过同店铺内的商品，暂时无法给到你此优惠，请晚点再来/.test(res.ErrMsg) ||
            res.ErrMsg === '当前商品已购买过，限购一件。独乐乐不如众乐乐，分享给好友吧' ||
            res.ErrMsg === '商品已临时下架，晚点再来看看吧'
          ) {
            MessageBox({
              title: '提示',
              message: res.ErrMsg,
              showCancelButton: true,
              confirmButtonText: '我知道了',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') {
                this.$router.push('souhuo')
              }
            })
          } else if (res.ErrMsg === '商品的免单活动结束') {
            this.changeToFreeCard('商品免单活动结束啦，是否继续购买？', false)
          } else if (res.ErrMsg === '商品已经加入免单活动') {
            this.changeToFreeCard('商品已加入免单活动，需要免单卡才能进行兑换，是否继续购买？', true)
          } else {
            if (res.ErrMsg) {
              Toast(res.ErrMsg)
            }
          }
        })
    },
    // 获取数据后续操作
    handleKeyAndTime(baseModeFn) {
      // 当前关键词的流量入口为【分享口令】时，展现复制按钮，无需必须超过20个字符 SearchType=4 分享口令
      // 若当前的关键词的流量入口类型为【直播口令】，则在关键词右侧直接展现【复制】按钮，无需必须超过20个字符
      let showCopyBtnWithoutRulesSearchTypes = [4, 5, 6]
      if (this.soHoInfo.SearchKey.replace(/\s*/g, '').length > 10 || showCopyBtnWithoutRulesSearchTypes.includes(this.soHoInfo.SearchType)) {
        this.isShowCopy = true
      } else {
        this.isShowCopy = false
      }
      this.isCounting = true
      this.goodsRemark = this.soHoInfo.Remark
      if (this.goodsRemark) {
        this.remarkArr = this.goodsRemark.split('；').filter((x) => {
          return x !== ''
        })
      }
      if (this.soHoInfo.OrderType) {
        this.isFreeCard = true
      } else {
        this.isFreeCard = false
      }
      // 新增逻辑 -- start
      this.handelCancelOrder(this.soHoInfo)
      // 新增逻辑 -- end
      // 针对拼多多基础销量模式数据获取
      if (baseModeFn) baseModeFn()
    },
    // 未关闭弹窗时，时间获取(避免关键词变更版本时，重新关联关键词)
    getServiceTime() {
      let params = {
        productID: this.productID,
        keywordId: this.soHoInfo.KeywordID
      }
      // 服务器-关联时间差
      KeyRelationTimeGet(params).then((res) => {
        let nowTime = parseInt(res.Data.NowTime.replace(/\D+/gi, ''))
        let relationTime = parseInt(res.Data.RelationTime.replace(/\D+/gi, ''))
        let diffTime = nowTime - relationTime
        this.diffSeconds = 120 - parseInt(diffTime / 1000)
        if (this.diffSeconds <= 0) {
          this.stopCounting()
        } else {
          this.countInterval = setInterval(this.countDown, 1000)
        }
      })
    },
    // 复制关键字
    copyKeyWord() {
      // console.log(123)
      if (document.execCommand) {
        var shopKeyWords = document.getElementById('shopKeyWords')
        shopKeyWords.focus()
        shopKeyWords.select()
        shopKeyWords.setSelectionRange(0, shopKeyWords.value.length)
        if (document.execCommand('copy', true, null)) {
          this.$toast({
            message: '复制成功',
            duration: 500
          })
        } else {
          MessageBox({
            title: '提示',
            message: '当前浏览器不支持复制功能，请长按选中文字，进行复制',
            confirmButtonText: '知道了',
            confirmButtonClass: 'c000'
          })
        }
        document.activeElement.blur()
      } else {
        MessageBox({
          title: '提示',
          message: '当前浏览器不支持复制功能，请长按选中文字，进行复制',
          confirmButtonText: '知道了',
          confirmButtonClass: 'c000'
        })
      }
    },
    // 加入提醒夹
    formSubmitRemind() {
      if (this.isSetting) return
      this.isSetting = true
      Indicator.open({
        text: '加入收藏中',
        spinnerType: 'triple-bounce'
      })
      ProductFavoriteAdd({ productId: this.productID })
        .then((res) => {
          Indicator.close()
          this.isSetting = false
          this.isNoProduct = false
          this.isRemind = true
          setTimeout(() => {
            this.$router.push('souhuo')
          }, 2000)
        })
        .catch((err) => {
          Indicator.close()
          this.isSetting = false
          Toast(err.ErrMsg)
        })
    },
    setCopyGuideInfo() {
      let offsetTop = this.$refs['howToSearch'].offsetTop
      let offsetHeight = this.$refs['howToSearch'].offsetHeight
      let offsetLeft = this.$refs['howToSearch'].offsetLeft
      let offsetWidth = this.$refs['howToSearch'].offsetWidth
      this.$nextTick(() => {
        let copyGuidePartOneOffsetHeight = this.$refs['copyGuidePartOne'].offsetHeight
        this.$refs['copyGuideMainPart'].style.transform = `translate(-50%, ${offsetHeight + offsetTop + 30}px)`
        this.$refs['copyGuidePartOne'].style.transform = `translate(${offsetLeft + offsetWidth}px, ${offsetTop - copyGuidePartOneOffsetHeight - 30}px)`
      })
    },
    isShowHowToSearchPopupHandler(SearchType) {
      let unShowSearchKeySearchTypes = [5, 6, 7]
      return unShowSearchKeySearchTypes.includes(SearchType)
    },
    isShowSearchKey(SearchType) {
      let unShowSearchKeySearchTypes = [7]
      return !unShowSearchKeySearchTypes.includes(SearchType)
    }
  },
  filters: {
    toFixed(value) {
      if (!value) {
        value = 0
      }
      return parseFloat(value).toFixed(2)
    },
    sortType(value) {
      var filterValue = '综合'
      if (value === 0) {
        filterValue = '综合'
      } else if (value === 1) {
        filterValue = '销量'
      } else if (value === 2) {
        filterValue = '价格低到高'
      } else if (value === 3) {
        filterValue = '价格高到低'
      } else {
        filterValue = '综合'
      }
      return filterValue
    }
  }
}
